/**
 * Returns the URL of the head-and-shoulders portrait generated by Nano Banana
 * for a given driver. Files live under /app/frontend/public/driver-portraits/
 * and are named after the driver's id. Fallback returns null so callers can
 * decide to show initials or a placeholder.
 */
export const getDriverPhoto = (driverIdOrDriver) => {
  if (!driverIdOrDriver) return null;
  const id = typeof driverIdOrDriver === 'string'
    ? driverIdOrDriver
    : (driverIdOrDriver.dataId || driverIdOrDriver.id);
  if (!id) return null;
  return `/driver-portraits/${id}.webp`;
};
